import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IClassifier } from '../../../models/Classifier';
import { AppService } from '../../../services/app.service';
import { StudentCourseEqualizationService } from '../../../services/student-course-equalization.service';

import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-student-course-equalization-approval',
    templateUrl: './student-course-equalization-approval.component.html',
    styleUrls: ['../student-course-equalization.component.scss']
})
export class StudentCourseEqualizationApprovalComponent {
    constructor(
        private app: AppService,
        private servcice: StudentCourseEqualizationService,
        private activeModal: NgbActiveModal
    ) { }

    @Input() set data(value: {
        id: number,
        comment: string,
        decisions: {
            decision: IClassifier, details: {
                course: string,
                ects?: string,
                comments?: string
            }[]
        }[],
        protocolUrl: string
    }) {
        this.id = value.id;
        this.comment = value.comment;
        this.decisions = value.decisions;
        this.protocolWarning = this.app.translate('studentCourseEqualization_protocolWarning').replace('{{url}}', value.protocolUrl);
    }

    id: number;
    comment: string;

    decisions: {
        decision: IClassifier, details: {
            course: string,
            ects?: string,
            comments?: string
        }[]
    }[] = [];

    protocolWarning: string;

    downloadProtocol(event) {
        if (event.target.nodeName == 'A') {
            event.preventDefault();
            this.app.addLoading(this.servcice.downloadProtocol(this.id, { approvalcomment: this.comment || '' })).subscribe();
        }
    }

    ok() {
        this.activeModal.close(true);
    }

    cancel() {
        this.activeModal.dismiss();
    }
}
